import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-task-filter-item',
  templateUrl: './task-filter-item.component.html',
  styleUrl: './task-filter-item.component.less'
})
export class TaskFilterItemComponent {
  @Input() options: any[] = [];
  @Input() labelKey = 'label';
  @Input() valueKey = 'value';
  @Input() multiple = true;
  @Input() value: string[] = [];
  @Output() filterChange = new EventEmitter();
  timer: number | null = null;

  handleSelect(item: any): void {
    const selectKey = item[this.valueKey];
    if (this.multiple) {
      if (!this.value.includes(selectKey)) {
        this.value.push(selectKey);
      } else {
        this.value = this.value.filter(it => it !== selectKey);
      }
    } else {
      if (!this.value.includes(selectKey)) {
        this.value = [selectKey];
      } else {
        this.value = [];
      }
    }
    if (this.timer) {
      clearTimeout(this.timer);
    }
    this.timer = window.setTimeout(() => {
      const value = this.value.length > 0 ? (this.multiple ? this.value : this.value[0]) : null;
      this.filterChange.emit(value);
    }, 350);
  }

  clearSelection(): void {
    this.value = [];
    this.filterChange.emit(null);
  }
}